import { useDroppable } from "@dnd-kit/core";
import React, {
    HTMLAttributes,
    ReactElement, ReactNode,
} from "react";

export interface SortableItemDroppableProps extends HTMLAttributes<HTMLDivElement> {
    children?: ReactNode;
    id: string
}

function SortableItemDroppable(props: SortableItemDroppableProps): ReactElement {
    const {
        children,
        id,
        ...rest
    } = props;

    const { setNodeRef } = useDroppable({
        id,
    });

    return (
        <div ref={setNodeRef} {...rest}>
            {children}
        </div>
    );
}

SortableItemDroppable.defaultProps = {
    children: undefined,
};

export default SortableItemDroppable;
